import classnames from "classnames"

import "./Stepper.scss"

interface StepperProps {
  index: number
  title: string
  max: number
  className?: string
}

const Stepper = ({ className, title, index, max }: StepperProps) => {
  const stepperClass = classnames("ds-stepper", className, {})
  const percentage = (index / max) * 100

  return (
    <div className={stepperClass}>
      <div
        className="ds-stepper__content"
        role="text"
        aria-label={`${title}, passo ${index} de ${max}`}
      >
        <p className="ds-stepper__title" aria-hidden="true">
          {title}
        </p>

        <p className="ds-stepper__state" aria-hidden="true">
          {index} de {max}
        </p>
      </div>

      <div className="ds-stepper__progress" aria-hidden>
        <div
          className="ds-stepper__bar"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  )
}

export default Stepper
